export default {
  nav: {
    home: "Inicio",
    products: "Productos",
    catalog: "Catálogo",
    about: "Sobre Nosotros",
    contact: "Contacto",
    language: "Idioma",
  },
  hero: {
    title: "Productos de Calidad para Cada Necesidad",
    subtitle:
      "Descubra nuestra colección premium diseñada para superar sus expectativas",
    cta: "Ver Catálogo",
    secondary: "Explorar Productos",
    viewAll: "Ver Todos los Productos",
  },
  products: {
    title: "Nuestros Productos",
    subtitle:
      "Explore nuestra selección cuidadosamente curada de productos premium",
    viewAll: "Ver Todos los Productos",
  },
  productCard: {
    viewDetails: "Ver Detalles",
    learnMore: "Más Información",
  },
  about: {
    title: "Sobre Nosotros",
    companyName: "Hebei Qianqin Metal Material Co., LTD",
    address: "Condado de Anping, Provincia de Hebei, China",
    manager: "Gerente Cici",
    managerPhone: "+86 18000609698",
    mrJake: "Sr. Jake",
    mrJakePhone1: "+86 18395601011",
    mrJakePhone2: "+86 15831188937",
    emailCici: "cici@qianqin-group.com",
    emailJake: "jake@qianqin-group.com",
    emailJames: "james@qianqin-group.com",
    website: "www.qianqin-group.com",
    scanQR: "Escanear Código QR",
    whatsapp: "WhatsApp",
    wechat: "WeChat",
  },
  catalog: {
    title: "Catálogo de Productos",
    download: "Descargar PDF",
    print: "Imprimir Catálogo",
    pdf: "/pdf/Qianqin-catalogue.pdf",
  },
  footer: {
    copyright: "© 2026 Qianqin. Todos los derechos reservados.",
    rights: "Todos los derechos reservados.",
  },
  common: {
    loading: "Cargando...",
    error: "Algo salió mal",
    retry: "Reintentar",
  },
  productsList: [
    {
      id: "1",
      name: "Producto Premium A",
      description: 'Producto de alta calidad con rendimiento excepcional y durabilidad. Perfecto para uso diario.',
      image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=800&q=80',
      pdf: "/pdf/Qianqin-catalogue.pdf",
    },
    {
      id: "2",
      name: "Producto Premium B",
      description: 'Diseño innovador que se encuentra con funcionalidad. Experimente la diferencia con nuestras ofertas premium.',
      image: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=800&q=80',
      pdf: "/pdf/Qianqin-catalogue.pdf",
    },
    {
      id: "3",
      name: "Producto Premium C",
      description: 'Elaborado con precisión y cuidado. Nuestros productos están construidos para superar las expectativas.',
      image: 'https://images.unsplash.com/photo-1572635196237-14b3f281503f?w=800&q=80',
      pdf: "/pdf/Qianqin-catalogue.pdf",
    },
    {
      id: "4",
      name: "Producto Premium D",
      description: 'Ingeniería avanzada que se encuentra con diseño elegante. Construido para profesionales que exigen excelencia.',
      image: 'https://images.unsplash.com/photo-1504274066631-90dd72c89d6d?w=800&q=80',
      pdf: "/pdf/Qianqin-catalogue.pdf",
    },
    {
      id: "5",
      name: "Producto Premium E",
      description: 'Materiales de calidad superior combinados con tecnología de vanguardia. El futuro de la productividad.',
      image: 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=800&q=80',
      pdf: "/pdf/Qianqin-catalogue.pdf",
    },
    {
      id: "6",
      name: "Producto Premium F",
      description: 'Diseñado meticulosamente para máxima eficiencia. Experimente un rendimiento incomparable.',
      image: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=800&q=80',
      pdf: "/pdf/Qianqin-catalogue.pdf",
    },
  ],
};
